import { DatePicker } from "@digital-services/ui";
import { usePaginationContext } from "@ds-cps/ui";

import { useAuditLogContext } from "@audit-log/context";
import { DateRangeValueType } from "@audit-log/models";

export const AuditLogDateRangeFilter = () => {
  const { setDateRangeFilter } = useAuditLogContext();
  const { pageIndex, setPageIndex } = usePaginationContext();

  return (
    <DatePicker
      locale={"en-GB"} // I added AT LEAST to match date-range format a bit => "28/09/2026, 13:00 - 16:00"
      mode="dateRangeTimeRange"
      onChange={date => {
        // This is to reset pagination when filtering by device type or state happens
        if (pageIndex !== 0) {
          setPageIndex(0);
        }

        setDateRangeFilter(date as DateRangeValueType);
      }}
      initialValue={undefined}
      isFutureDisabled
    />
  );
};
